import {initialState} from "./state"

export const setLibrary = (state, payload) => {
  state.library = payload
}

export const setPlaylistMedia = (state, payload) => {
  state.playlistMedia = state.playlistMedia.concat(payload)
}

export const setUploadingMediaList = (state, payload) => {
  state.uploadingMediaList = payload
}

export const removeFromUploadingList = (state, index) => {
  state.uploadingMediaList.splice(index, 1)
}

export const setUploadProcessing = (state, payload) => {
  state.uploadProcessing = payload
}

export const setUploadingMedia = (state, {index, attributes}) => {
  attributes.forEach(({key, value}) => {
    state.uploadingMediaList[index][key] = value
  })
}

export const reset = (state) => {
  const s = initialState()

  Object.keys(s).forEach(key => {
    state[key] = s[key]
  })
}
